import { Skeleton } from '@mui/material';
import { FC } from 'react';

const UploadPictureSkeleton: FC = () => {
  return (
    <section>
      <Skeleton animation="wave" variant="circular" height={150} width={150} />
      <div>
        <Skeleton animation="wave" variant="text" />
        <Skeleton animation="wave" variant="text" />
      </div>
    </section>
  );
};

export default UploadPictureSkeleton;
